import { Row, theme } from 'antd';
import { FilterMeta } from '../../../../hooks/adminPage/filters/useFilterMeta';
import FilterAllConditions, { ConditionTypeMap } from './FilterAllConditions';

export enum ConditionSectionTypeMap {
    FILTER = 'FILTER',
    USER_FILTER = 'USER_FILTER',
    AUTOMATION = 'AUTOMATION',
    ADVANCED_REPORT = 'ADVANCED_REPORT'
}
interface Props {
    allConditions: FilterMeta['allConditions'];
    anyConditions: FilterMeta['anyConditions'];
    sectionType?: ConditionSectionTypeMap;
    isCreateMode?: boolean;
}

const TicketConditionsContainer = ({
    allConditions = [],
    anyConditions = [],
    sectionType = ConditionSectionTypeMap.FILTER,
    isCreateMode = false
}: Props) => {
    const {
        token: { marginMD }
    } = theme.useToken();
    return (
        <Row gutter={[0, marginMD]}>
            <FilterAllConditions
                allConditions={allConditions}
                sectionType={sectionType}
                isCreateMode={isCreateMode}
                conditionType={ConditionTypeMap.TICKET_ALL_CONDITIONS}
            />
            <FilterAllConditions
                allConditions={anyConditions}
                sectionType={sectionType}
                isCreateMode={isCreateMode}
                conditionType={ConditionTypeMap.TICKET_ANY_CONDITIONS}
            />
        </Row>
    );
};

export default TicketConditionsContainer;
